module.exports = __webpack_public_path__ + "img/activate-admin-download-app.5607af3d.webp";